export function BuildVersion() {
  return <>{BUILD_VERSION}</>
}
